<h1>IPD Transaction<span *ngIf="this.IpdDetails">&nbsp;({{this.IpdDetails.patient}})</span><span *ngIf="this.IpdDetails">&nbsp;({{this.IpdDetails.treatmentName}})</span><span *ngIf="this.IpdDetails">&nbsp;({{this.IPDsurgDate}})</span><button type="button" (click)="CloseModal()" class="btn btn-default float-right">Close</button></h1>
<div class="row"  *ngIf="!dataLoaded"><i class="fa fa-spin fa-spinner"></i></div>
<div class="row" *ngIf="dataLoaded">
    <div class="col-sm-12">
    <form [formGroup]="IpdForm" (submit)="SubmitData()">
        <div class="form-group">
            <div class="row">
                <div class="col-sm-3">
                    <label class="form-label">Doctor Name</label>
                    <input type="text" formControlName="doctor_name" class="form-control readOnly" />
                </div>
                <div class="col-sm-3">
                    <label class="form-label">Hospital Name</label>
                    <input type="text" formControlName="hospital_name" class="form-control readOnly" />
                </div>
                <div class="col-sm-3">
                    <label class="form-label">BD Name</label>
                    <input type="text" formControlName="user_name" class="form-control readOnly" />
                </div>
                <div class="col-sm-3">
                    <label class="form-label">Payment Mode</label>
                    <mat-select placeholder="Select Payment Mode" formControlName="payment_mode" class="readOnly">
                        <mat-option value="">Select Payment Mode</mat-option>
                        <mat-option [value]="1">Cash</mat-option>
                        <mat-option [value]="2">Cashless</mat-option>
                        <mat-option [value]="3">Reimbursement</mat-option>
                        <mat-option [value]="4">EMI</mat-option>
                    </mat-select>
                </div>
            </div>
        </div>
        <div class="card-footer">
            <!-- <button type="submit" [disabled]="loading" class="btn btn-primary" ><i *ngIf="loading" class="fa fa-spin fa-spinner"></i> Update</button> -->
            <table class="table table-striped hospitalTable">
                <thead>
                    <tr>
                        <th class="td1">Particular</th>
                        <th class="td2"></th>
                        <th class="td3"></th>
                        <th class="td4">Amount(Rs.)</th>
                        <th class="td5"></th>
                        
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td class="td1"><strong>Billed Amount</strong></td>
                        <td class="td2"></td>
                        <td class="td3"></td>
                        <td class="td4">
                            <input type="text" formControlName="billed_amt" class="form-control text-left" readonly/>
                        </td>
                        <td class="td5"></td>
                    </tr>
                    <tr>
                        <td class="td1"><strong>Settlement Amount</strong></td>
                        <td class="td2"></td>
                        <td class="td3"></td>
                        <td class="td4">
                            <input type="text" formControlName="settled_amt" class="form-control text-left" readonly/>
                        </td>
                        <td class="td5"></td>
                    </tr>
                    <tr>
                        <td class="td1"><strong>Hospital Share</strong></td>
                        <td class="td2"></td>
                        <td class="td3"></td>
                        <td class="td4">
                            <input type="number" (keyup)="calculate_glamyoShare()"  formControlName="hospital_share" class="form-control text-left" [readonly]="isReadOnly ? 'readonly' : null"/>
                            <div *ngIf="submitted && f.hospital_share.errors" class="invalid-feedback">
                                <div *ngIf="f.hospital_share.errors.required">Hospital Share is required</div>
                            </div>
                        </td>
                        <td class="td5"></td>
                    </tr>
                    <tr>
                        <td class="td1"><strong>Doctor Share</strong></td>
                        <td class="td2"></td>
                        <td class="td3"></td>
                        <td class="td4">
                            <input type="number" (keyup)="calculate_glamyoShare()"  formControlName="doctor_share" class="form-control text-left" />
                            <div *ngIf="submitted && f.doctor_share.errors" class="invalid-feedback">
                                <div *ngIf="f.doctor_share.errors.required">Doctor Share is required</div>
                            </div>
                        </td>
                        <td class="td5"></td>
                    </tr>
                    <tr *ngIf="!isReadOnly">
                        <td class="td1 cursorPointer" (click)="addQuantity()">Add Ipd Resourses <i class="fa fa-plus" aria-hidden="true"></i></td>
                        <td class="td2"></td>
                        <td class="td3"></td>
                        <td class="td4"></td>
                        <td class="td5"></td>
                        
                    </tr>
                    <div *ngIf="!isReadOnly" class="col-sm-12" formArrayName="ipdResources" style="display: contents;">
                        <tr *ngFor="let quantity of ipdResources().controls; let i=index" [formGroupName]="i">
                            <td class="td1"></td>
                            <td class="td2">
                                <mat-select placeholder="Select Type" formControlName="resourceType" (selectionChange)="GetResourcesData($event.value,i)">
                                    <mat-option value="">Select Type</mat-option>
                                    <mat-option [value]="1">Consumables</mat-option>
                                    <mat-option [value]="2">Lapset Vendor</mat-option>
                                    <mat-option [value]="3">Anaesthetist</mat-option>
                                </mat-select>
                            </td>
                            <td class="td3">
                                <mat-select placeholder="Select" formControlName="resourceName">
                                    <mat-option value="">Select</mat-option>
                                    <mat-option [value]="rs.id" *ngFor="let rs of resourseNameList[i]" (click)="PatchPriceData(i,rs)">{{rs.name}}</mat-option>
                                </mat-select>
                            </td>
                            <td class="td2"  *ngIf="IpdForm.controls['ipdResources'].value[i].resourceType!=3">
                                <mat-select placeholder="Select Vendor Name" formControlName="vendor_id" (click)="setSearchValue('vendor')">
                                    <input class="mySearchInput"
                                    #vendorSearch focused="'true'" type="text"
                                    (keyup)="searchOnSelect($event.target.value, 'vendor')"
                                    (keydown)="$event.stopPropagation()" autocomplete="off"
                                    placeholder="Search"
                                    id="vendorSearch">
                                    <mat-option [value]="vendorData.id" *ngFor="let vendorData of vendorNameList">{{vendorData.vendor_name}}</mat-option>
                                </mat-select>
                            </td>
                            <td class="td4">
                                <input type="number" formControlName="resourcePrice" class="form-control text-left" (keyup)="calculate_glamyoShare()" [readonly]="disableSelect[i]"/>
                            </td>
                            <input type="hidden" formControlName="resourceId" >
                            <td class="td5">
                                <!-- <button (click)="removeQuantity(i)" class="btn btn-danger">Remove</button> -->
                                <button
                                        class="btn btn-danger"
                                        mwlConfirmationPopover
                                        [popoverTitle]="popoverTitle"
                                        [popoverMessage]="popoverMessage"
                                        [confirmText]="confirmText"
                                        [cancelText]="cancelText"
                                        [placement]="placement"
                                        (confirm)="removeQuantity(i)"
                                        (cancel)="cancelClicked = true"
                                        confirmButtonType="danger"
                                        cancelButtonType="outline-secondary"
                                        (click)="confirmClicked = false; cancelClicked = false"
                                        [appendToBody]="true">
                                    Remove
                                </button>
                            </td>
                            
                        </tr>
                    </div>
                   
                    <tr *ngIf="!isReadOnly">
                        <td class="td1"></td>
                        <td class="td2"><div *ngIf="glamyoLoss && IpdForm.controls['billed_amt'].value!=0" style="color: red;"><strong>Loss</strong></div></td>
                        <td class="td3"><strong>Glamyo Share</strong></td>
                        <td class="td4">

                            <input type="text" id="glamshare" formControlName="glamyo_share" class="form-control text-left" [ngClass]="{'lossClass':glamyoLoss}" readonly/>
                        </td>
                        <td class="td5"></td>
                    </tr>
                   
                </tbody> 
                </table> 
        </div>
        <div class="card-footer">
            <!-- [disabled]="glamyoShare=='0'" -->
            <button  type="submit" class="btn btn-primary" ><i *ngIf="loading" class="fa fa-spin fa-spinner"></i>
                <span>Submit</span>
            </button>
        </div>
        </form>
    </div>
</div>